import React from "react";

export function KYC() {
  return <iframe src="https://vitreus.io/kyc/" className={`w-full h-full`} />;
}
